import { t } from "i18next";
import React from "react";
import QuestionMark from '../assets/svgs/question-line.svg'

const CheckSN=()=>{

    const [check, set_check] = React.useState(false);

    return(
        <div className="container mx-auto py-5">
            <h1 className="font-bold text-2xl">{t('check_status_warranty')}</h1>

            <div className="flex flex-col items-center">
                <div>
                    <input type="text" placeholder={t('input_sn')} className="border border-gray-300 rounded-md p-2 w-80 mt-5 text-sm"/>
                    <div className="mt-3 flex flex-row items-start cursor-pointer" onClick={() => console.log('how to identify')}>
                        <QuestionMark className="w-5 h-5 inline-block mr-1"/>
                        <p className="text-xs text-neutral-600 my-auto">{t('how_to_identify_sn')}</p>
                    </div>
                </div>
            </div>
            <div className="mt-5 flex w-96 flex-row mx-auto items-center">
                <input type="checkbox" className="w-8 mb-auto" value={check} onChange={() => set_check(!check)}/>
                <p className="text-xs text-left w-80 mt-auto">{t('aggrement_text')} <a href="#" className="text-blue-700">{t('privacy_policy')}</a> ADVAN</p>
            </div>
            <div>
                <button disabled={!check} onClick={() => console.log('submit')} className={`${check ? 'bg-blue-700' : 'bg-blue-300'} text-white w-80 p-2 rounded-md mt-5`}>{t('send')}</button>
            </div>
        </div>
    )

}

export default CheckSN;